const key = (locale, currency) => {
    return `${locale}-${currency}`;
};
const BASE_OPTIONS = {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
};
const SM_NBSP = '\u202f'; // small non-breaking space
const NBSP = '\xa0'; // normal non-breaking space
const formatAmount = (price, thousandSeparator, withDecimal = true) => {
    const [intPart, decimalPart] = price.toFixed(2).toString().split('.');
    let intPartFormatted;
    if (thousandSeparator === '') {
        intPartFormatted = intPart;
    }
    else {
        intPartFormatted = '';
        for (let i = intPart.length; i > 0; i -= 3) {
            intPartFormatted = `${intPart.substring(Math.max(i - 3, 0), i)}${i === intPart.length ? '' : thousandSeparator === 'space' ? SM_NBSP : thousandSeparator}${intPartFormatted}`;
        }
    }
    return intPartFormatted + (withDecimal ? `,${decimalPart}` : '');
};
const formatCurrency = (amount, symbol, place) => {
    if (place === 'start') {
        return `${symbol}${NBSP}${amount}`;
    }
    return `${amount}${NBSP}${symbol}`;
};
const CUSTOM_FORMATTERS = {
    [key('bg-BG', 'EUR')]: (price) => formatCurrency(formatAmount(price, 'space'), '€', 'end'),
    [key('bg-BG', 'BGN')]: (price) => formatCurrency(formatAmount(price, 'space'), 'лв.', 'end'),
    [key('cs-CZ', 'CZK')]: (price) => formatCurrency(formatAmount(price, 'space', false), 'Kč', 'end'),
    [key('da-DK', 'DKK')]: (price) => formatCurrency(formatAmount(price, '.'), 'kr', 'start'),
    [key('de-CH', 'CHF')]: (price) => formatCurrency(formatAmount(price, '.'), 'CHF', 'end'),
    [key('es-ES', 'EUR')]: (price) => formatCurrency(formatAmount(price, '.'), '€', 'end'),
    [key('fr-CH', 'CHF')]: (price) => formatCurrency(formatAmount(price, '.'), 'CHF', 'end'),
    [key('hr-HR', 'EUR')]: (price) => formatCurrency(formatAmount(price, '.'), '€', 'end'),
    [key('hu-HU', 'EUR')]: (price) => formatCurrency(formatAmount(price, 'space'), '€', 'end'),
    [key('it-IT', 'EUR')]: (price) => formatCurrency(formatAmount(price, '.'), '€', 'start'),
    [key('pl-PL', 'PLN')]: (price) => formatCurrency(formatAmount(price, 'space'), 'zł', 'end'),
    [key('pt-PT', 'EUR')]: (price) => formatCurrency(formatAmount(price, '.'), '€', 'end'),
    [key('ro-RO', 'EUR')]: (price) => formatCurrency(formatAmount(price, '.'), '€', 'end'),
    [key('ro-RO', 'RON')]: (price) => formatCurrency(formatAmount(price, '.'), 'LEI', 'end'),
    [key('ru-RU', 'EUR')]: (price) => formatCurrency(formatAmount(price, '.'), '€', 'end'),
    [key('sk-SK', 'EUR')]: (price) => formatCurrency(formatAmount(price, '.'), '€', 'end'),
    [key('sl-SI', 'EUR')]: (price) => formatCurrency(formatAmount(price, '.'), '€', 'start'),
};
const CACHED_DEFAULT_FORMATTERS = {};
const formatPrice = (price, locale, currency) => {
    const priceNonNull = price || 0;
    const k = key(locale, currency);
    const customFormatter = CUSTOM_FORMATTERS[k];
    if (customFormatter) {
        return customFormatter(priceNonNull);
    }
    else {
        let formatter = CACHED_DEFAULT_FORMATTERS[k];
        if (!formatter) {
            formatter = new Intl.NumberFormat(locale, { ...BASE_OPTIONS, style: 'currency', currency });
            CACHED_DEFAULT_FORMATTERS[k] = formatter;
        }
        return formatter.format(priceNonNull);
    }
};

export { NBSP, SM_NBSP, formatAmount, formatPrice };
//# sourceMappingURL=priceService.js.map
